import workspace from "./workspace";

export const getDatabaseConfigs = async () => {
  try {
    const response = await workspace.get(`/database-config/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching database configs:", error);
    throw error;
  }
};

export const getDatabaseConfigById = async (id) => {
  try {
    const response = await workspace.get(`/database-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching database config with ID ${id}:`, error);
    throw error;
  }
};

export const createDatabaseConfig = async (configData) => {
  try {
    const response = await workspace.post(`/database-config/`, configData, {
    });
    return response.data;
  } catch (error) {
    console.error("Error creating database config:", error);
    throw error;
  }
};

export const updateDatabaseConfig = async (id, configData) => {
  try {
    const response = await workspace.put(`/database-config/${id}/`, configData, {
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating database config with ID ${id}:`, error);
    throw error;
  }
};

export const partialUpdateDatabaseConfig = async (id, configData) => {
  try {
    const response = await workspace.patch(`/database-config/${id}/`, configData, {
    });
    return response.data;
  } catch (error) {
    console.error(`Error partially updating database config with ID ${id}:`, error);
    throw error;
  }
};

export const deleteDatabaseConfig = async (id) => {
  try {
    const response = await workspace.delete(`/database-config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting database config with ID ${id}:`, error);
    throw error;
  }
};

// Additional service methods for specific functionality

export const getActiveDatabaseConfigs = async () => {
  try {
    const response = await workspace.get(`/database-config/`, {
      params: { is_active: true }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching active database configs:", error);
    throw error;
  }
};